// No Gateway API keys or OTP secrets in the browser. Administrator tokens
// are memory-only and are never written to localStorage or URLs.
const BASE='https://population-coming-bpa-email-gateway-mask.pockethost.io';
async function decode(response){
  const body=await response.json().catch(()=>({}));
  if(!response.ok||body.success===false)
    throw new Error('Gateway returned HTTP '+response.status+': '+(body.message||'Assessment service request failed.'));
  return body.data||body;
}
export async function publicCatalog(){
  const r=await fetch(BASE+'/api/bpa-assessments/catalog',{
    method:'GET',mode:'cors',cache:'no-store',headers:{'Accept':'application/json'}
  });
  const data=await decode(r);
  // A malformed response must not masquerade as an empty published library.
  if(data.version!==1||!Array.isArray(data.assessments))
    throw new Error('The Gateway returned an invalid assessment catalog.');
  return data.assessments;
}
export async function signIn(identity,password){
  const response=await fetch(BASE+'/api/collections/users/auth-with-password',{
    method:'POST',cache:'no-store',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({identity,password})});
  const data=await response.json().catch(()=>({}));
  if(!response.ok||!data.token)throw new Error('Sign-in failed. Check your Gateway administrator credentials.');
  return data.token;
}
export async function adminAction(token,action,payload={}){
  if(!token)throw new Error('Please sign in as an administrator.');
  const response=await fetch(BASE+'/api/bpa-assessments/admin',{
    method:'POST',cache:'no-store',
    headers:{'Content-Type':'application/json','Authorization':'Bearer '+token},
    body:JSON.stringify({action,...payload})});
  if(response.status===401||response.status===403)throw new Error('Administrator access denied. Please sign in with a verified, authorised Gateway account.');
  return decode(response);
}